import type { ReactNode } from 'react'
import { UploadFilesActionPanel } from '../../shared/UploadFilesActionPanel'
import { DataTableV2UploadFilesAction } from '../types'

export function UploadFilesActionSheet({
  action,
  uploadNamespace,
  trigger,
}: {
  action: DataTableV2UploadFilesAction
  uploadNamespace: string
  trigger: ReactNode | ((onOpen: () => void) => ReactNode)
}) {
  return (
    <UploadFilesActionPanel
      action={action}
      title={action.label}
      uploadNamespace={uploadNamespace}
      permissions={action.permissions}
      trigger={trigger}
    />
  )
}
